import React from 'react';
import {Container} from '@material-ui/core';
import {FirebaseContext} from '../../Firebase';
import {Button, TextField} from '@material-ui/core';
import ReactGoogleSlides from 'react-google-slides';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Coffre from '../../../images/coffre.png';
import Code from '../../../images/code.png';

const Session13 = () => {
  const firebase = React.useContext(FirebaseContext);
  const group = firebase.userData.group;
  const [scr, setScr] = React.useState(0);
  const [CR, setCR] = React.useState(false);
  const [response, setResponse] = React.useState('');
  const [respQ, setRespQ] = React.useState('');
  const [respQStatus, setRespQStatus] = React.useState(false);
  const setRespCorrect = (int) => {
    if (int.toString().length >= 3) {
      if (int.toString() === '248') {
        setRespQStatus(true);
      } else {
        setRespQStatus(false);
      }
    }
  };
  return (
    <div>
      <Container
        style={{
          backgroundColor: 'lightblue',
          padding: '10px',
          minHeight: '270px',
        }}
      >
        {/* SCREENS INTRO ALL GROUP*/}
        {scr === 0 && (
          <div>
            <h3>Bienvenue dans cette nouvelle session !</h3>
            <p>
              Au fil des dernières semaines, tu as pu découvrir à quoi ressemble
              l’altruisme ici, près de chez nous. Nous allons maintenant partir
              à la découverte de l’altruisme à travers les cultures du monde.
            </p>
            <p>
              Clique sur le bouton continuer une fois que tu as bien compris
              pour continuer.
            </p>
          </div>
        )}
        {scr === 1 && (
          <div style={{textAlign: 'center', width: '100%'}}>
            <ReactGoogleSlides
              width={'100%'}
              height={480}
              slidesLink="https://docs.google.com/presentation/d/1VSJ_h-vneVoKztf1wi7VRAUCeWT_7VUt_Xlog8q8KcI"
              position={0}
              showControls
            />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend">
                L’étude présentée a observé la réaction aux visages exprimant :
              </FormLabel>
              <RadioGroup
                aria-label="team"
                defaultValue=""
                name="radio-buttons-group-team"
                onChange={(e) => {
                  setCR(true);
                  setResponse(e.target.value);
                }}
              >
                <FormControlLabel
                  value="joie"
                  control={<Radio />}
                  label="De la joie"
                />
                <FormControlLabel
                  value="tristesse"
                  control={<Radio />}
                  label="De la tristesse"
                />
                <FormControlLabel
                  value="peur"
                  control={<Radio />}
                  label="De la peur"
                />
              </RadioGroup>
            </FormControl>
          </div>
        )}
        {/* SCREENS CONTROL*/}
        {group.toString() === 'control' && scr === 2 && (
          <div>
            <p>
              Pour continuer cette session, nous te proposons une petite énigme.
            </p>
          </div>
        )}
        {group.toString() === 'control' && scr === 3 && (
          <div>
            <p>
              Ta mission du jour : trouver le code à trois chiffres qui permet
              d’ouvrir le coffre-fort.
            </p>
            <img
              src={Coffre}
              alt="coffre-fort"
              style={{width: '30%', marginLeft: '20%'}}
            />
            <br />
            <br />
            <p>
              Nous avons plusieurs indices pour toi, prends ton temps pour les
              lire et une fois que tu as trouvé, rentre les trois chiffres dans
              les cases correspondantes, dans l’ordre.
            </p>
            <p>
              <img
                src={Code}
                alt="code"
                style={{width: '30%', marginLeft: '20%'}}
              />
            </p>
            <p style={{marginLeft: '20%', display: 'flex', gap: '20px'}}>
              <TextField
                rows="1"
                id="num"
                label="le code"
                variant="outlined"
                value={respQ}
                onChange={(e) => {
                  setRespQ(e.target.value);
                  setRespCorrect(e.target.value);
                }}
              />
              Le code que tu as donné est :{' '}
              {respQ.length >= 3 && (respQStatus ? 'correct !' : 'incorrect')}
            </p>

            <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
          </div>
        )}
        {group.toString() === 'control' && scr === 4 && (
          <div>
            <p>
              Nous avons terminé pour aujourd’hui. Bravo pour l’organisation de
              ce spectacle !
            </p>
            <p>
              N’oublie pas de te connecter dans quelques jours pour la prochaine
              séance.
            </p>
            <p>Merci pour ta participation !</p>
            <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
          </div>
        )}
        {/* SCREENS TEST*/}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 2 && (
            <div>
              <p>
                Prêt pour la prochaine aventure avec tes camarades bénévoles ?
              </p>
              <p>
                Nous venons d’apprendre que tout ne se passe pas comme prévu…
                peut être que tu vas pouvoir nous aider à trouver une solution !
              </p>
            </div>
          )}
        {group.toString() === 'test_a' && scr === 3 && (
          <div>
            <p>
              Aujourd’hui, l’association a organisé une opération de ramassage
              de déchets dans un grand parc de la ville. Munis de gants et de
              sacs poubelle, le groupe a prévu d’aller nettoyer un parc pour que
              les petits et les grands puissent profiter de la nature.
            </p>
            <p>
              Mais il y a un problème… le parc est fermé à cause du vent, par
              mesure de sécurité !
            </p>
            <p>
              Tous les gants et sacs étaient prêts, et l’ensemble de tes
              camarades étaient volontaires pour aider à faire cette action avec
              toi.
            </p>
            <p>A toi maintenant de réfléchir avec eux à une solution. </p>
          </div>
        )}

        {group.toString() === 'test_b' && scr === 3 && (
          <div>
            <p>
              Aujourd’hui, l’association a organisé une visite de personnes
              âgées hospitalisées avec des chansons. Munis de partitions et de
              bonne humeur, le groupe a prévu de se rendre à l’hôpital et
              d’égayer la journée des patients.
            </p>
            <p>
              Mais il y a un problème… le service est fermé aux visites parce
              qu’il manque des soignants aujourd’hui !
            </p>
            <p>
              Tout le matériel était prêt, et l’ensemble de tes camarades
              étaient volontaires pour aider à faire cette action avec toi.
            </p>
            <p>A toi maintenant de réfléchir avec eux à une solution. </p>
          </div>
        )}
        {group.toString() === 'test_c' && scr === 3 && (
          <div>
            <p>
              Aujourd’hui, l’association a organisé une distribution de plats
              chauds pour les personnes sans domicile fixe. Munis de table et de
              plats livrés par les restaurants, le groupe a prévu de se rendre
              sur une place de la ville pour la distribution.
            </p>
            <p>
              Mais il y a un problème… le camion pour apporter tous les plats
              sur place est tombé en panne !
            </p>
            <p>
              Tout le matériel était prêt, et l’ensemble de tes camarades
              étaient volontaires pour aider à faire cette action avec toi.
            </p>
            <p>A toi maintenant de réfléchir avec eux à une solution. </p>
          </div>
        )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 4 && (
            <div>
              <p>Voici ce qu’en pensent tes camarades :</p>
              <p>
                Anaïs : « Moi je pense qu’on devrait tout annuler, c’est trop
                compliqué de tout changer d’un coup… »
              </p>
              <p>Idriss : « Mais non, on va trouver une autre solution, aller à un
              autre endroit par exemple ! » </p>
              <p>Clara : « On devrait appeler
              quelqu’un de la ville, peut-être qu’ils auront des idées… »</p>
              <p>Et
              toi, quelle solution proposerais-tu ? Toutes les suggestions sont
              les bienvenues pour aider à trouver une solution et mener une
              action avec le matériel disponible !</p>
              <p>  Écris tes idées dans l’espace
              ci-dessous.</p>
              <TextField
              multiline
              fullWidth
                rows="4"
                id="num"
                label="le code"
                variant="outlined"
                value={respQ}
                onChange={(e) => {
                  setRespQ(e.target.value);
                }}
              />
              
            </div>
          )}
           {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 5 && (
            <div>
              <p>
                Nous avons terminé pour aujourd’hui. N’oublie pas de te
                connecter dans quelques jours pour la prochaine séance.
              </p>
              <p>Merci pour ta participation !</p>
              <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
            </div>
          )}
      </Container>
      {/* BUTTON*/}
      <Button
        style={{display: 'block', margin: 'auto'}}
        disabled={scr === 1 && !CR}
        variant="contained"
        color="primary"
        onClick={() => {
          if (scr === 3) {
            // save TEST DATA
            let now = new Date();
            firebase
              .databehav(firebase.userData.pseudo)
              .collection('session13')
              .add({
                date: now,
                response: response,
                respCode: respQ,
              })
              .catch((error) => {
                console.log(error);
              });
          }
          if ((scr === 4&&group.toString() === 'control')||scr === 5) {
            firebase.signoutUser();
          } else {
            setScr(scr + 1);
          }
        }}
      >
        Continuer
      </Button>
    </div>
  );
};
export default Session13;
